/* global FB */
// React
import React from 'react'
// Components
import Icon from '../Display/Icon'

const shareOverrideOGMeta = (overrideLink, overrideTitle, overrideDescription, overrideImage) => {
	FB.ui({
		method: 'share_open_graph',
		action_type: 'og.shares',
		action_properties: JSON.stringify({
			object: {
				'og:url': overrideLink,
				'og:title': overrideTitle,
				'og:description': overrideDescription,
				'og:image': overrideImage
			}
		})
	},
	function (response) {
		console.log(response);
	})
}

export default ({ title, description, image }) => {
	const url = window.location.protocol + "//" + window.location.host
	title = title ? title + ' | Moon Sign App' : 'Moon Sign App'
	description = description ? description : 'Discover your astrological moon zodiac sign with this app.'
	image = image ? url + '/assets/images/' + image : url + '/assets/images/logo.png'
	return (
		<div>
			<div className='lpa-social'>
				<div className='lpa-social-container'>
					<div className='lpa-social-item' onTouchTap={() => shareOverrideOGMeta(window.location.href, title, description, image)}>
						<Icon name='facebook' size='24' color='facebook' />
					</div>
					<div className='lpa-social-item' onTouchTap={() => window.open('https://twitter.com/intent/tweet?text=' + escape('Check out the Moon Sign App: discover your astrological moon zodiac sign with this app.') + '&url=' + escape(window.location.href) + '&via=MoonSignApp&related=LifePurposeApp,ConsciousApps,Life%20Purpose%20App', '_system')}>
						<Icon name='twitter' size='24' color='twitter' />
					</div>
					<div className='lpa-social-item' onTouchTap={() => window.open('https://www.linkedin.com/shareArticle?mini=true&url=' + escape(window.location.href) + '&title='+escape('Moon Sign App')+'&summary='+escape('Discover your astrological moon zodiac sign with this app.'), '_system')}>
						<Icon name='linkedin' size='24' color='linkedin' />
					</div>
					<div className='lpa-social-item' onTouchTap={() => window.open('https://plus.google.com/share?url=' + escape(window.location.href), '_system')}>
						<Icon name='google' size='24' color='google' />
					</div>
					<div className='lpa-social-item' onTouchTap={() => window.open('https://api.addthis.com/oexchange/0.8/forward/email/offer?url=' + escape(window.location.href) + '&pubid=ra-42fed1e187bae420&title=' + escape('Moon Sign App: discover your astrological moon zodiac sign with this app.'), '_system')}>
						<Icon name='email-outline' size='24' color='email' />
					</div>
				</div>
			</div>
			<div className='capps-height-20' />
			<div className='capps-height-20' />
		</div>
	)
}



// WEBPACK FOOTER //
// ./src/Components/Display/Social.js